<template>
  <v-main class="editor-layout">
    <editor-mode-toggle></editor-mode-toggle>

    <editor-navigation-bar></editor-navigation-bar>

    <editor-navigation-drawer></editor-navigation-drawer>

    <v-container fluid v-if="$store.state.editor.drawer.type != 'section-builder'" class="py-0">
      <v-row>
        <v-col>
          <v-card
            class="editor-preview-card"
            :class="`screen-mode-${$store.state.editor.screenMode.name}`"
            elevation="2"
            tile
            :max-width="$store.state.editor.screenMode.size"
          >
            <v-card-text class="pa-0">
              <slot></slot>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <section-builder-preview v-else></section-builder-preview>
  </v-main>
</template>

<script>
import '@/assets/scss/webble.editor.scss'
import '@/assets/scss/webble.frontend.scss'
import '@/assets/scss/webble.mobile.scss'
import EditorNavigationDrawer from '@/components/editor/EditorNavigationDrawer'
import EditorNavigationBar from '@/components/editor/EditorNavigationBar'
import EditorModeToggle from '@/components/editor/EditorModeToggle'
import SectionBuilderPreview from '@/components/editor/types/SectionBuilder/SectionBuilderPreview'

export default {
  name: 'EditorLayout',
  components: {
    EditorNavigationDrawer,
    EditorNavigationBar,
    EditorModeToggle,
    SectionBuilderPreview
  }
}
</script>

<style scoped>
.editor-preview-card {
  margin: 0 auto;
}
.editor-preview-card {
  transition: max-width 0.3s ease 0s;
}
</style>
